import { elevateAutocomplete } from "tools/elevateClient";

export default async function elevateSearch(query, config, isMobile, state, setState) {
	const searchResults = await elevateAutocomplete(
        query,
        isMobile ? 'mobile' : 'desktop'
    );

    let products = [];
    let content = [];

    searchResults?.products?.productSuggestions.forEach((productSuggestions) => {
        products.push(productSuggestions.products[0]);
    });
    searchResults?.content?.primaryList.items.forEach((contentItem) => {
        content.push(contentItem);
    });

	if (searchResults) {
		setState(state => {
			return {
				...state,
				focus: true,
				products: products.slice(0, 9),
				content: content.slice(0, 9),
				suggestions: searchResults.products.phraseSuggestions,
				hitCount: searchResults.products.totalHits + searchResults.content.primaryList.totalHits
			};
		});
	}
}

module.exports = elevateSearch;
